export default {
  // 标签区
  tabDisable: '二维码禁用',
  tabPageConfig: '禁用页面配置',
  // 操作栏
  addDisable: '添加禁用',
  // 搜索区
  batchCode: '码批次',
  batchCodePlaceholder: '请输入码批次',
  qrcode: '二维码',
  qrcodePlaceholder: '请输入二维码',
  disableTime: '禁用时间',
  startTime: '开始时间',
  endTime: '结束时间',
  // 表格列
  colBatchSn: '码批次',
  colQrcodeRange: '二维码区间',
  colQrcodeCount: '二维码数量',
  colForbidMessage: '禁用原因',
  colCreatedAt: '禁用时间',
  colAction: '操作',
  // 操作列
  releaseDisable: '解除禁用',
  edit: '编辑',
  // 解除确认
  confirmReleaseTitle: '确认解除禁用',
  confirmReleaseContent: '确定要解除该码的禁用状态吗？',
  // 添加/编辑弹窗
  addDisableTitle: '添加禁用',
  editDisableTitle: '编辑禁用',
  batchCodeRequired: '请选择码批次',
  batchSn: '码批次',
  batchSnPlaceholder: '请选择二维码批次',
  forbidType: '禁用类型',
  forbidTypeAll: '整批禁用',
  forbidTypePartial: '部分禁用',
  startCode: '起始码',
  startCodePlaceholder: '请输入起始码',
  startCodeRequired: '请输入起始码',
  endCode: '结束码',
  endCodePlaceholder: '请输入结束码',
  endCodeRequired: '请输入结束码',
  smallSerialStart: '小序号起',
  smallSerialStartPlaceholder: '请输入小序号起始值',
  smallSerialEnd: '小序号止',
  smallSerialEndPlaceholder: '请输入小序号结束值',
  forbidMessage: '禁用提示',
  forbidMessagePlaceholder: '请输入禁用提示语',
  forbidMessageRequired: '请输入禁用提示',
  remark: '备注',
  remarkPlaceholder: '请输入备注',
  // 空状态
  emptyText: '暂无禁用记录',
  // 禁用页面配置
  pageTitle: '页面标题',
  pageTitleRequired: '请至少输入一种语言的页面标题',
  tipImage: '提示图片',
  textColor: '文字颜色',
  bgColor: '页面背景颜色',
  resetDefaultImage: '恢复默认图',
  resetDefaultColor: '恢复默认颜色',
  defaultPreviewTitle: '二维码异常',
  defaultTipImage: '禁用图片',
  defaultTipText: '禁用提示语禁用提示语禁用提示语',
};
